import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { FanProvider } from "./contexts/FanContext";
import { PlayerProvider } from "./contexts/PlayerContext";
import { ShopProvider } from "./contexts/ShopContext";

// Pages
import Landing from "./pages/Landing";
import Mixes from "./pages/Mixes";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Calendar from "./pages/Calendar";
import Bookings from "./pages/Bookings";
import NewArtists from "./pages/NewArtists";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import OrderSuccess from "./pages/OrderSuccess";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";

// Layout
import MainLayout from "./components/MainLayout";

function App() {
  return (
    <BrowserRouter>
      <FanProvider>
        <PlayerProvider>
          <ShopProvider>
            <Routes>
              {/* Public Routes with Main Layout */}
              <Route element={<MainLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/mixes" element={<Mixes />} />
                <Route path="/events" element={<Events />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/new-artists" element={<NewArtists />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/cart" element={<Cart />} />
                <Route path="/shop/order-success" element={<OrderSuccess />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<Admin />} />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </ShopProvider>
        </PlayerProvider>
      </FanProvider>
    </BrowserRouter>
  );
}

export default App;
